module.exports = __webpack_public_path__ + "static/visitShop-f35c31a64f012884e9b216b66b67bbfb.png";